import { makeStyles, Theme, createStyles, Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ProductApi from "../../../api/services/ProductApi";
import CustomButton from "../../../components/Button/CustomButton";
import { tesaWhite } from "../../../styles/colors";
import UnknownProductOverviewTable from "./UnknownProductOverviewTable";
import UnknownProductEditCreateDialog from "./UnknownProductEditCreateDialog";
import useQueryParams from "../../../hooks/useQueryParams.hook";
import UnknownProductAlert from "./UnknownProductAlert";
import useEnv from "../../../hooks/env";
import { TestRequestTabType } from "../../Requests/useTestRequestParams";
import { UnknownProduct } from "../../../api/models/product/UnknownSampleAddFormType";
import { CustomTableRowData } from "../../../components/CustomTable";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(3),
    },
    link: {
      color: tesaWhite,
      fontFamily: "Proxima Nova Bold",
      textDecoration: "none",
      "&:hover": {
        color: "rgb(70, 71, 117)",
      },
    },
    marginBottomM: {
      marginBottom: theme.spacing(3),
    },
    marginBottomL: {
      marginBottom: theme.spacing(5),
    },
    marginRight: {
      marginRight: theme.spacing(4),
    },
    ul: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
    },
  }),
);

const UnknownProductDbOverview = () => {
  const { api } = useEnv();
  const productApi = new ProductApi(api);
  const history = useHistory();
  const queryParams = useQueryParams();
  const backReference = queryParams.get("backReference");
  const backReferenceTab = queryParams.get("backReferenceTab");
  const hasBackReference = Boolean(backReference) && Boolean(backReferenceTab);

  const classes = useStyles();
  const [unknownProductPagedRes, setUnknownProductPagedRes] = useState<ProductRaw.Schemas.UnknownProductPagedResult>();
  const [isAddUnknownProductDialogOpen, setIsAddUnknownProductDialogOpen] = useState(false);
  const [isEditableProduct, setIsEditableProduct] = useState(true);
  const [unknownProductInitialData, setUnknownProductInitialData] = useState<UnknownProduct>();
  const [submissionSuccessful, setSubmissionSuccessful] = useState(false);

  const handleClose = (success: boolean) => {
    if (success) {
      setSubmissionSuccessful(true);
    }
    setIsAddUnknownProductDialogOpen(false);
    setSubmissionSuccessful(false);
  };

  useEffect(() => {
    productApi
      .getUnknownProducts()
      .then((res) => {
        setUnknownProductPagedRes(res.data);
      })
      .catch((e) => console.log(e));
  }, [submissionSuccessful]);

  const handleEdit = (row: CustomTableRowData) => {
    productApi.isEditableCompetitorProduct(row.id).then(({ data: isEditable }) => {
      if (isEditable !== isEditableProduct) {
        setIsEditableProduct(isEditable);
      }
      setUnknownProductInitialData(unknownProductPagedRes?.data?.find((elm) => elm.id === row.id) as UnknownProduct);
      setIsAddUnknownProductDialogOpen(true);
    });
  };

  return (
    <div className={classes.root}>
      <h2>Unknown Product Database</h2>
      <Box className={classes.marginBottomL} />
      <UnknownProductAlert className={classes.marginBottomL} />
      <div>
        <CustomButton
          className={[classes.marginBottomM, classes.marginRight].join(" ")}
          add
          onClick={() => {
            setIsAddUnknownProductDialogOpen(true);
          }}
          text="Create Unknown Product"
        />
        {hasBackReference ? (
          <CustomButton
            className={classes.marginBottomM}
            onClick={() => {
              history.push(
                `/requests/${backReference}/${backReferenceTab}${
                  backReferenceTab === TestRequestTabType.PRODUCT.toString()
                    ? "/addUnknownProduct"
                    : "/addSubstrateSample?type=UNKNOWN_PRODUCT"
                }`,
              );
            }}
            text="Back to Request"
          />
        ) : (
          <></>
        )}
      </div>
      <UnknownProductOverviewTable
        unknownProductPagedRes={unknownProductPagedRes}
        setUnknownProductPagedRes={setUnknownProductPagedRes}
        handleEdit={handleEdit}
      />
      <UnknownProductEditCreateDialog
        initialData={unknownProductInitialData}
        readonly={!isEditableProduct}
        open={isAddUnknownProductDialogOpen}
        onClose={handleClose}
        exitedCallback={() => setUnknownProductInitialData(undefined)}
      />
    </div>
  );
};

export default UnknownProductDbOverview;
